import * as types from './types';
import { createReducer } from '../../utils';

const initialState = {
  lastStep: '1',
  lastModule: '0',
  error: null
};

const stepperReducer = createReducer(initialState)({
  [types.GET_POSTING_LAST_STEP]: state => ({ ...state, error: null }),
  [`${types.GET_POSTING_LAST_STEP}_COMPLETED`]: (state, action) => ({
    ...state,
    lastStep: action.payload.step,
    lastModule: action.payload.module
  }),
  [`${types.GET_POSTING_LAST_STEP}_FAILED`]: (state, action) => ({
    ...state,
    error: action.payload
  }),
  [types.UPDATE_LAST_STEP]: (state, action) => {
    if (
      state.lastStep < action.payload.step ||
      (state.lastStep === action.payload.step && state.lastModule < action.payload.module)
    ) {
      return {
        ...state,
        lastStep: action.payload.step,
        lastModule: action.payload.module
      };
    }
    return state;
  }
});

export { stepperReducer };
